import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ef9292cc"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cyimu/Desktop/shiliang/vgo/VGO_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef9292cc')) {
      api.createRecord('ef9292cc', component.options)
    } else {
      api.reload('ef9292cc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ef9292cc", function () {
      api.rerender('ef9292cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/application/wxAccount/wxTemplate/index.vue"
export default component.exports